import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_API_KEY;
const isPlaceholder = !POSTHOG_KEY || POSTHOG_KEY.includes('PLACEHOLDER');

if (!isPlaceholder) {
  posthog.init(POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
    loaded: (ph) => {
      if (process.env.NODE_ENV === 'development') ph.opt_out_capturing();
    },
  });
}

export const isPostHogActive = !isPlaceholder;
export default posthog;
